import { IFilters } from "types/configurations"

export const filterTextForTable = (text: string, selectedFilters?: IFilters) => {
  if (
    text &&
    selectedFilters.search &&
    selectedFilters.search !== '' &&
    text.toLowerCase().indexOf(selectedFilters.search.toLowerCase()) >= 0
  ) {
    const searchRegex = new RegExp(selectedFilters.search, 'gi')
    return text.replace(
      searchRegex,
      '<span class="bg-textMarker font-bold">$&</span>'
    )
  }
  return text
}